import React from 'react';

interface propsArrowLink {
	className?: string,
	onClick?: () => void,
}

function ArrowLink({ className, onClick }: propsArrowLink) {
	return (
		<div
			onClick={onClick}
			className={`arrow-link ${className}`}
		>
			<span></span>
		</div>
	);
}

export default ArrowLink;
